import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyDXTleL4dhUDnUKJDky_LqLUetCpRLbFQQ",
    authDomain: "clone-7bbcb.firebaseapp.com",
    projectId: "clone-7bbcb",
    storageBucket: "clone-7bbcb.appspot.com",
    messagingSenderId: "482305113601",
    appId: "1:482305113601:web:0505391dfe7e3a0c11ca00",
    measurementId: "G-V7WCS0F4FT"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db=firebaseApp.firestore();
  const auth = firebase.auth();

  export {db , auth };